import React from "react";
import Header from "../../components/orrbiitheader";
import Footer from "../../components/footerorrbiit";

export default function AboutPage() {
  return (
    <>
      <Header />

      {/* MAIN WRAPPER */}
      <div
        style={{
          backgroundColor: "#f7ead7",
          minHeight: "100vh",
          padding: "30px 0", // reduced from 40
        }}
      >
        <div className="container" style={{ maxWidth: "900px" }}>

          {/* HERO */}
          <div className="text-center mb-4">
            <h1 style={{ fontWeight: "700" }}>Orrbiit Group</h1>
            <p style={{ fontSize: "18px", color: "#555", marginBottom: "6px" }}>
              One Vision. Multiple Ventures.
            </p>
            <p style={{ color: "#666", marginBottom: "0" }}>
              Delivering beauty, travel, and social impact services with trust and innovation.
            </p>
          </div>

          {/* WHO WE ARE */}
          <section className="mb-4">
            <h3 className="mb-2">Who We Are</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              Orrbiit is a multi-venture company focused on delivering high-quality services across
              different sectors. Our aim is to simplify everyday needs through reliable, accessible,
              and customer-first solutions. We are building a strong ecosystem where services are
              not only convenient but also trustworthy and efficient.
            </p>
          </section>

          {/* OUR VENTURES */}
          <section className="mb-4">
            <h3 className="mb-2">Our Ventures</h3>

            <p style={{ marginBottom: "6px" }}>
              <strong>Orrbiit Elegance:</strong> Professional beauty and salon services delivered at home with convenience and care.
            </p>

            <p style={{ marginBottom: "6px" }}>
              <strong>Orrbiit Go:</strong> Smart and reliable cab and travel services designed for comfort and efficiency.
            </p>

            <p>
              <strong>Orrbiit Relief:</strong> A social initiative focused on helping communities through impactful NGO activities.
            </p>
          </section>

          {/* MISSION */}
          <section className="mb-4">
            <h3 className="mb-2">Our Mission</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              Our mission is to create a trusted platform that connects people with essential
              services seamlessly while maintaining quality, affordability, and reliability.
            </p>
          </section>

          {/* VISION */}
          <section className="mb-4">
            <h3 className="mb-2">Our Vision</h3>
            <p style={{ color: "#444", lineHeight: "1.7" }}>
              We aim to become a leading multi-service brand that enhances everyday life by
              integrating services across industries into one strong and dependable ecosystem.
            </p>
          </section>

          {/* WHY CHOOSE US */}
          <section className="mb-4">
            <h3 className="mb-2">Why Choose Us</h3>
            <ul style={{ lineHeight: "1.7", color: "#444", paddingLeft: "18px" }}>
              <li>Trusted and reliable services</li>
              <li>Customer-first approach</li>
              <li>High-quality service delivery</li>
              <li>Growing multi-service ecosystem</li>
            </ul>
          </section>

          {/* VALUES */}
          <section className="mb-3">
            <h3 className="mb-2">Our Values</h3>
            <ul style={{ lineHeight: "1.7", color: "#444", paddingLeft: "18px" }}>
              <li>Integrity and transparency</li>
              <li>Customer satisfaction</li>
              <li>Innovation and growth</li>
              <li>Social responsibility</li>
            </ul>
          </section>

        </div>
      </div>

      <Footer />
    </>
  );
}